import axios from 'axios'

const getUserStatusList = async (organizationId, programId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/userstatus`
        );
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
}
export default getUserStatusList